module.exports = __webpack_public_path__ + "img/experience_enhancement_2.3c431737.png";